import React from 'react';
import { Box, CircularProgress, Tooltip } from '@mui/material';
import {
  SEVERITY_LEVELS,
  SEVERITY_LEVEL_CONFIG,
  type SeverityLevel
} from '../../constants/severityLevel';

interface SeveritySemaphoreSelectorProps {
  value: SeverityLevel | '';
  onChange: (value: SeverityLevel) => void;
  disabled?: boolean;
  loading?: boolean;
}

const SeveritySemaphoreSelector: React.FC<SeveritySemaphoreSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  loading = false
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} role="radiogroup" aria-label="Severidad">
      {SEVERITY_LEVELS.map((level) => {
        const config = SEVERITY_LEVEL_CONFIG[level];
        const selected = value === level;
        return (
          <Tooltip key={level} title={config.label}>
            <Box
              component="button"
              type="button"
              role="radio"
              aria-checked={selected}
              aria-label={config.ariaLabel}
              disabled={disabled}
              onClick={() => onChange(level)}
              sx={{
                width: 28,
                height: 28,
                borderRadius: '50%',
                border: '2px solid',
                borderColor: selected ? 'text.primary' : 'transparent',
                bgcolor: config.color,
                cursor: disabled ? 'default' : 'pointer',
                opacity: disabled ? 0.5 : value && !selected ? 0.45 : 1,
                p: 0,
                outline: selected ? '2px solid' : 'none',
                outlineColor: 'text.primary',
                outlineOffset: 2,
                transition: 'opacity 0.15s, transform 0.15s',
                '&:hover:not(:disabled)': { transform: 'scale(1.08)' }
              }}
            />
          </Tooltip>
        );
      })}
      {loading && <CircularProgress size={16} />}
    </Box>
  );
};

export default SeveritySemaphoreSelector;
